import { render, staticRenderFns } from "./Emprendedores.vue?vue&type=template&id=14b479e8&"
import script from "./Emprendedores.vue?vue&type=script&lang=js&"
export * from "./Emprendedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports